import { render } from "./ExpenseTypeAutocomplete.vue?vue&type=template&id=15ec57b2&scoped=true"
import script from "./ExpenseTypeAutocomplete.vue?vue&type=script&lang=js"
export * from "./ExpenseTypeAutocomplete.vue?vue&type=script&lang=js"

import "./ExpenseTypeAutocomplete.vue?vue&type=style&index=0&id=15ec57b2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ec57b2"]])

export default __exports__